// extracted by mini-css-extract-plugin
export default {"buttons":"externalCourses_buttons__oTDfs","dropdownManage":"externalCourses_dropdownManage__0BB1M","search":"externalCourses_search__MECc3"};